import { useCallback } from 'react'
import { useForm } from 'react-hook-form'
import DAITextBox from '../../DAIComponents/Input/Text/DAITextBox'
import { Product, ProductFormData, productSchema } from './ProductsTypes'
import { ModalProps } from '../../DAIComponents/Modal/ModalProps'
import useProductContext from '../../hooks/useProductContext'
import DAIModal from '../../DAIComponents/Modal/DAIModal'
import { DAIForm } from 'src/DAIComponents/Form/DAIForm'
import DAIButton from 'src/DAIComponents/Input/Button/DAIButton'
import { zodResolver } from '@hookform/resolvers/zod'

export default function CreateProductModal({
  initialData,
  closeModal,
  isOpen,
}: ModalProps<Product>) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<ProductFormData>({
    resolver: zodResolver(productSchema),
    defaultValues: initialData,
  })
  const { editProduct, createProduct } = useProductContext()

  const onSubmit = useCallback(
    (data: ProductFormData) => {
      if (initialData) {
        const product: Product = {
          ...data,
          id: initialData.id,
        }
        editProduct(product)
      } else {
        createProduct(data as Product)
      }
      closeModal()
    },
    [createProduct, editProduct, closeModal, initialData]
  )

  return (
    <DAIModal isOpen={isOpen} onClose={closeModal}>
      <DAIForm onSubmit={handleSubmit(onSubmit)} className="space-y-4">
        <DAITextBox
          name="name"
          label="Product Name"
          register={register('name')}
          required={true}
          error={errors.name?.message}
        />
        <DAITextBox
          name="description"
          label="Description"
          register={register('description')}
          error={errors.description?.message}
        />
        <div className="mt-6 flex items-center justify-end gap-x-6">
          <DAIButton
            buttonType="button"
            text="Cancel"
            variant="secondary"
            onClick={() => closeModal()}
          />
          <DAIButton buttonType="submit" text="Save" variant="primary" />
        </div>
      </DAIForm>
    </DAIModal>
  )
}
